export default {
  INSERT_INTO_ALL: "INSERT_INTO_ALL_BRF_BRF_PLANNED_RAISES",
  ADD_TO_IN_PROGRESS: "ADD_TO_IN_PROGRESS_BRF_BRF_PLANNED_RAISES",
  REMOVE_FROM_IN_PROGRESS: "REMOVE_FROM_IN_PROGRESS_BRF_BRF_PLANNED_RAISES",
  INSERT_INTO_FORMS: "INSERT_INTO_FORMS_BRF_BRF_PLANNED_RAISES",
  DESTROY_FORM: "DESTROY_FORM_BRF_BRF_PLANNED_RAISES",
  SET_FORM_ERROR: "SET_FORM_ERROR_BRF_BRF_PLANNED_RAISES",
  UPDATE_FORM_INSTANCE: "UPDATE_FORM_INSTANCE_BRF_BRF_PLANNED_RAISES",
  INSERT_INTO_PAGINATION: "INSERT_INTO_PAGINATION_BRF_BRF_PLANNED_RAISES",
  INSERT_INTO_FILTERED: "INSERT_INTO_FILTERED_BRF_BRF_PLANNED_RAISES",
  RESET_STATE: "RESET_STATE_BRF_BRF_PLANNED_RAISES",
  SET_ASK_DELETE_DATA: "SET_ASK_DELETE_DATA_BRF_BRF_PLANNED_RAISES",
  REMOVE_OBJECT: "REMOVE_OBJECT_BRF_BRF_PLANNED_RAISES",
  CLEAR_FETCHED: "CLEAR_FETCHED_BRF_BRF_PLANNED_RAISES",

  LIST_URL: "/brf/plannedfeeraise/list/",
  POST_URL: "/brf/plannedfeeraise/",
  PATCH_URL: "/brf/plannedfeeraise/",
  GET_URL: "/brf/plannedfeeraise/",

  STORE_NAME: "brfPlannedRaises",
};
